export default __webpack_public_path__ + "static/media/pp.4d12348e.jpg";